import { ApolloError } from '@apollo/client';
import { getAccessTokenCookie, getRefreshTokenCookie, getUserDataCookie } from '@netfront/common-library';

const RECOVERY_RETRY_DELAYS_IN_MILLISECONDS = Object.freeze([2000, 5000, 10000]);

const getLoginRoute = () => `/login?requestedRoute=${encodeURIComponent(window.location.pathname)}`;

const hasAccessToken = () => Boolean(getAccessTokenCookie());

const hasRecoverableSession = () => Boolean(getRefreshTokenCookie() && getUserDataCookie());

const isTemporaryError = (error: Error) => {
  if (!(error instanceof ApolloError) || !error.networkError) {
    return false;
  }

  const { statusCode } = error.networkError as { statusCode?: number };

  return statusCode === undefined || statusCode === 408 || statusCode === 429 || statusCode >= 500;
};

export { getLoginRoute, hasAccessToken, hasRecoverableSession, isTemporaryError, RECOVERY_RETRY_DELAYS_IN_MILLISECONDS };
